import { Component, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { DeleteModel } from '../../core/models/dele.model';
import { Config } from '../../core/DefaultConfig';
import { UserRegistrationAddEditDialogComponent } from './user-registration-add-edit-dialog/user-registration-add-edit-dialog.component';
import { DeleteDialogComponent } from '../../shared/delete-dialog/delete-dialog.component';
import { GenericCrudService } from '../../core/services/generic-crud.service';
import { AppUrlConstants } from '../../core/constants/AppUrlConstants';
import { AlertDialogComponent } from '../../shared/alert-dialog/alert-dialog.component';
import { RolePipe } from '../../core/pipes/role.pipe';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getCustomPaginatorIntl } from '../../shared/paginator.helper';


@Component({
  selector: 'app-user-registration',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule, MatPaginatorModule,
    MatCardModule, MatIconModule, MatButtonModule, MatGridListModule, TranslateModule, RolePipe],
  providers: [
    { provide: MatPaginatorIntl, useValue: getCustomPaginatorIntl('Users per page') }
  ],
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.css']
})

export class UserRegistrationComponent {
  displayedColumns: string[] = ['sr', 'userName', 'email', 'mobile', 'role', 'status', 'action'];
  config = new Config();

  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  deleteModel: DeleteModel = {
    title: "DELETE_TITLE",
    message: "USER_DELETE_MESSAGE",
    deleteButtonText: "DELETE",
    cancelButtonText: "CALCEL"
  };

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(public dialog: MatDialog, private crudService: GenericCrudService) {
    {
      this.dataSource = new MatTableDataSource();
      this.dataSource.sortingDataAccessor = (item, property) => {
        const value = item[property];
        return typeof value === 'string' ? value.toLowerCase() : value;
      };
    }
  }

  ngOnInit() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      const value = item[property];
      return typeof value === 'string' ? value.toLowerCase() : value;
    };// Set case-insensitive sorting globally
    this.getUsers();

  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  ngAfterViewInit(): void {
    // Attach paginator and sort after view initialization
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  getUsers() {
    this.crudService.getAll(AppUrlConstants.USER_URL + AppUrlConstants.ACTIVE_INACTIVE_USERS_INTERNAL_LIST).subscribe({
      next: (res: any) => {
        // Update the data in the existing MatTableDataSource
        this.dataSource.data = res?.data || [];

        // Attach paginator and sort to the existing dataSource
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        // Add case-insensitive sorting logic
        this.dataSource.sortingDataAccessor = (item, property) => {
          const value = item[property];
          return typeof value === 'string' ? value.toLowerCase() : value;
        };
      },
      error: (e) => {
        console.error('Error fetching data:', e);
      }
    });
  }
  add() {
    const dialogRef = this.dialog.open(UserRegistrationAddEditDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }

    });
  }
  edit(updateRecord: any, rowNumber: number) {
    const dialogRef = this.dialog.open(UserRegistrationAddEditDialogComponent, {
      data: updateRecord,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }

    });
  }
  delete(deleteRecord: any, rowNumber: number) {

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: this.deleteModel
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.crudService.delete(deleteRecord?.userId, AppUrlConstants.USER_URL).subscribe({
          next: (res: any) => {
            this.dataSource = new MatTableDataSource(res?.data);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          },
          error: (e) => {
            if (e?.status == 409) {
              if (e?.error?.errors !== null) {
                for (const property in e.error.errors) {
                  this.openAlert(e.error.errors[property]);
                }
              } else {
                this.openAlert(e?.error?.message);
              }
            }
          }
        });
      }
    });

  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }
}
